// 日语
export default {
  // 水果转盘
  fruitTurntable: {
    recordsTitle: "履歴",
    emptyRecords: "フルーツルーレットの履歴はありません",
    guessResult: "予想結果",
    myGuesses: "自分の予想",
    guessFailed: "予想が外れました",
    winningPlayers: "勝利したプレイヤー",
    noGuesses: "このラウンドでは予想していません",
    noWinners: "このラウンドに勝利したプレイヤーはいません",
    rulesTitle: "遊び方",
    rulesDescription: "各ラウンドの予想時間は50秒です。出現するフルーツを予想し、的中すると対応する露の報酬を獲得できます。",
    guessingTitle: "予想方法",
    guessingDescription: "予想時間内に賭ける露の数を選び、画面のフルーツのベットエリアをタップして予想します。",
    rewardsTitle: "報酬について",
    rewardsDescription: "フルーツによって獲得できる露の報酬が異なります。",
    fruit: "フルーツ",
    multiplier: "報酬倍率",
    apple: "リンゴ",
    watermelon: "スイカ",
    orange: "オレンジ",
    banana: "バナナ",
    grape: "ブドウ",
  },
  setPresident: {
    intro: "社長を任命して社団の管理を任せることができます",
    selfIntro: "あなたは社団の社長です",
    president: "社長",
    empty: "社長未設定",
    appoint: "任命する",
    privileges: "社長の権限",
    privilegesIntro: "社長には以下の権限があります",
    title: "社長を設定",
    selectMember: "社長に任命するメンバーを選択してください",
    member: "メンバー",
    attendance: "出席{days}日",
    weekContribution: "名声貢献（週）:",
    monthContribution: "（月）:",
    confirmAppoint: "このメンバーを社長に任命しますか？",
    confirm: "確認",
    remove: "任命を解除",
    cancel: "キャンセル",
    removeTitle: "社長の任命を解除",
    confirmRemove: "{name}の社長任命を解除しますか？",
    unnamed: "名前未設定",
    pkTitle: "PKルーム",
    pkDesc: "社長は社団のPKルームの開設、閉鎖、管理ができます",
    infoTitle: "社団情報",
    infoDesc: "社長と領主は社団のカバー画像、名前、宣言などの情報を編集できます",
    membersTitle: "メンバー管理",
    membersDesc: "社長と領主は社団のメンバーやゲストを削除できます",
    rewardsTitle: "社団報酬",
    rewardsDesc: "社長は社団の報酬を受け取れます。社長が未設定の場合は受け取れません",
    moderationTitle: "配信ルーム管理",
    moderationDesc: "社長は領主の配信ルームの管理権限を自動的に取得します",
    newPlayersTitle: "新規プレイヤーチャンネル",
    newPlayersDesc: "社長と領主は新規プレイヤーチャンネルを閲覧できます",
    loadMembersFailed: "メンバー一覧を取得できませんでした",
    appointFailed: "社長を任命できませんでした",
    appointSuccess: "任命しました",
    removeFailed: "任命を解除できませんでした",
    removeSuccess: "任命を解除しました",
    customerService: "カスタマーサポート",
    loadClubFailed: "社団情報を取得できませんでした",
  },
  /* 总榜 */
  allRank: {
    lang1: "放送局",
    lang2: "リッチ",
    lang3: "PK",
    lang4: "クラブバトル",
    lang5: "中国語",
    lang6: "英語",
    lang7: "タイ語",
    lang8: "日本語",
    lang9: "インドネシア語",
    lang10: "ベトナム語",
    lang11: "時間",
    lang12: "毎日",
    lang13: "毎週",
    lang14: "今週",
    lang15: "先週",
    lang16: "毎月",
    lang17: "ランク一覧",
    lang18: "褒美",
    lang19: "接続率",
    lang20: "クラブポイント",
    lang21: "メンバー",
    lang22: "データなし",
    lang23: "まだリストされていません",
    lang24: "ファンクラブ",
    lang25: "日付",
    lang26: "自分自身をフォローできません",
    lang27: "正常にフォローしました",
    lang28: "フォローを解除しました",
    lang29: "待っている",
    lang30: "昨日",
    lang31: "先月",
    lang32: "リストに載っていない",
    lang33: "私のランキング",
    lang34: "使者",
    lang35: "月間報酬リスト",
    lang36: "弟子の月間リスト",
    lang37: "Club",
    lang38: "Fans group",
    lang39: "スローガンなし",
    lang40: "メンバー",
    lang41: "メンバー",
    lang42: "週間評判",
    lang43: "総評判",
    lang44: "クラブランキング",
    lang45: "共有",
    lang46: "起動",
    lang47: "クラブ招待状を送信",
    lang48: "ライブ放送をもっと楽しむために FIREFLY を起動",
    lang49: "週間報酬ランキング",
    lang50: "週間金額ランキング",
    lang51: "名声",
    lang52: "報酬",
  },

  /* 俱乐部 */
  club: {
    lang1: "放送局",
    lang2: "リッチ",
    lang3: "PK",
    lang4: "クラブバトル",
    lang5: "中国語",
    lang6: "英語",
    lang7: "タイ語",
    lang8: "日本語",
    lang9: "インドネシア語",
    lang10: "ベトナム語",
    lang11: "時間",
    lang12: "毎日",
    lang13: "毎週",
    lang14: "今週",
    lang15: "先週",
    lang16: "毎月",
    lang17: "ランク一覧",
    lang18: "褒美",
    lang19: "接続率",
    lang20: "クラブポイント",
    lang21: "メンバー",
    lang22: "データなし",
    lang23: "まだリストされていません",
    lang24: "ファンクラブ",
    lang25: "日付",
    lang26: "自分自身をフォローできません",
    lang27: "正常にフォローしました",
    lang28: "フォローを解除しました",
    lang29: "待っている",
    lang30: "点寄与図",
    lang31: "等級",
    lang37: "Club",
    lang38: "Fans group",
    lang39: "スローガンなし",
    lang40: "メンバー",
    lang41: "メンバー",
    lang42: "週間評判",
    lang43: "総評判",
    lang44: "クラブランキング",
    lang45: "共有",
    lang46: "起動",
    lang47: "クラブ招待状を送信",
    lang48: "FIREFLYを起動して、クラブに参加して一緒に遊ぼう~",
    lang49: "Fans group",
    lang50: "領主：",
    lang51: "会長：",
    // クラブランキング「自分の順位」行のロールバッジ。
    lang52: "領主",
    lang53: "会長",
    lang54: "メンバー",

    lang55: "クラブ所属なし",

    lang56: "クラブ所属が設定されていません",
  },

  /* 榜单 */
  rank: {
    lang1: "放送局",
    lang2: "リッチ",
    lang3: "PK",
    lang4: "クラブバトル",
    lang5: "中国語",
    lang6: "英語",
    lang7: "タイ語",
    lang8: "日本語",
    lang9: "インドネシア語",
    lang10: "ベトナム語",
    lang11: "時間",
    lang12: "毎日",
    lang13: "毎週",
    lang14: "今週",
    lang15: "先週",
    lang16: "毎月",
    lang17: "ランク一覧",
    lang18: "褒美",
    lang19: "接続率",
    lang20: "クラブポイント",
    lang21: "メンバー",
    lang22: "データなし",
    lang23: "まだリストされていません",
    lang24: "ファンクラブ",
    lang25: "日付",
    lang26: "自分自身をフォローできません",
    lang27: "正常にフォローしました",
    lang28: "フォローを解除しました",
    lang29: "待っている",
    lang30: "昨日",
    lang31: "先月",
    lang32: "リストに載っていない",
    lang33: "私のランキング",
    newDraw96: "プライベート通話",
  },

  /* TOP hub */
  topRankList: {
    title: "FIREFLY TOP Center",
    playerCoreTitle: "Player Core TOP",
    playerCoreSubTitle: "Top Rich",
    anchorCoreTitle: "Broadcaster Core TOP",
    anchorCoreSubTitle: "Top FIREs",
    playerCenterTitle: "Player Rankings",
    playerCenterSubTitle: "Ranking Center",
    anchorCenterTitle: "Broadcaster Rankings",
    anchorCenterSubTitle: "FIREs Ranking Center",
    richBoard: "FIREFLY Rich Ranking",
    anchorBoard: "FIREFLY Broadcaster Ranking",
    clubBoard: "Club Ranking",
    emissaryBoard: "Emissary Ranking",
    mountBoard: "Car Ranking",
    ludoBoard: "LUDO PK Ranking",
    gardenBoard: "Firefly Garden Ranking",
    firstLoveBoard: "FirstLove Ranking",
    newStarBoard: "New Star Ranking",
    pkBoard: "PK Ranking",
    privateCreditBoard: "Private Credit Ranking",
  },

  /* 珍愛團 */
  treasureGroup: {
    lang1: "放送局",
    lang2: "リッチ",
    lang3: "PK",
    lang4: "クラブバトル",
    lang5: "中国語",
    lang6: "英語",
    lang7: "タイ語",
    lang8: "日本語",
    lang9: "インドネシア語",
    lang10: "ベトナム語",
    lang11: "時間",
    lang12: "毎日",
    lang13: "毎週",
    lang14: "今週",
    lang15: "先週",
    lang16: "毎月",
    lang17: "ランク一覧",
    lang18: "褒美",
    lang19: "接続率",
    lang20: "クラブポイント",
    lang21: "メンバー",
    lang22: "データなし",
    lang23: "まだリストされていません",
    lang24: "ファンクラブ",
    lang25: "日付",
    lang26: "自分自身をフォローできません",
    lang27: "正常にフォローしました",
    lang28: "フォローを解除しました",
    lang29: "待っている",
    lang30: "点寄与図",
    lang31: "等級",
    lang37: "Club",
    lang38: "Fans group",
    lang39: "スローガンなし",
    lang40: "メンバー",
    lang41: "メンバー",
    lang42: "週間評判",
    lang43: "総評判",
    lang44: "クラブランキング",
    lang45: "共有",
    lang46: "起動",
    lang47: "クラブ招待状を送信",
    lang48: "ライブ放送をもっと楽しむために FIREFLY を起動",
  },

  /* 珍愛值記錄 */
  treasureRecord: {
    recordTitle2: "大切な記録",
    income10: "今月",
    income11: "先月",
    news7: "問題",
    news13: "Fan Value",
    cashreal6: "キャンセル",
    box1: "まだ記録はありません",
  },

  /* 俱乐部说明页 */
  groupIntruduction: {
    lang1: "クラブの紹介",
    lang2:
      "クラブは、アンカーのコアファンで構成されたグループです。クラブに入会すると、一緒に楽しいイベントやコンテストに参加したり、同じクラブのメンバーと友達になったりすることができます。ファングループの数と評判は、クラブの主な競争ポイントであり、創設アンカーの影響力と人気を象徴するものでもあります。",
    lang3: "クラブの専門属性の紹介",
    lang4: "C.by クリエイター:",
    lang5:
      "クラブの創設者、通常はアンカー。アンカーは、フォローした人数が一定数に達するとクラブを開設します。",
    lang6: "P.by会長：",
    lang7:
      "クラブのマネージャーは、ホストによって指定された後に有効になります。クラブの会長は、C.byクリエイターのライブ放送ルームマネージャーにもなります。",
    lang8: "メンバー:",
    lang9:
      "クラブのメンバー。入会方法は、生放送中に「Cherish You」または「Cherish Together」ギフトを送ることです。どのクラブにもメンバー数に制限はありません。",
    lang10: "限定プレゼント：",
    lang11:
      "クラブコンテストでは、特別なギフトが贈られます。クラブギフトを送ってクラブポイントを獲得しましょう。",
    lang12: "クラブポイント：",
    lang13:
      "1.クラブ創設者のライブ放送ルームでクラブ限定ギフトを送信して、クラブポイントを貯めます。 2.クラブ創設者のライブ放送ルームで毎日のクラブタスクを完了して、クラブポイントを貯めます。",
    lang14: "評判:",
    lang15:
      "同じクラブのメンバー全員のクラブポイントの合計がクラブの評判です。クラブのメンバー全員が毎週増やしたクラブポイントの合計がクラブの毎週の評判です。",
    lang16: "メンバーのレベル",
    lang17:
      "1.クラブポイントを貯めるプロセスは、アップグレードを完了するプロセスです。詳細については、上記のアイコンを参照してください。 2.クラブギフトの送信。1ジェム= 1クラブポイント（ギフトの他の属性には影響しません）。 3. クラブポイントは当日の上限に達すると、それ以上増加しなくなります。",
    lang18: "メンバーのダウングレード",
    lang19:
      "1. クラブでは、メンバーが3日連続でクラブポイントを寄付しなかった場合、4日目からクラブポイントが減少し始めます。 2. クラブポイントが継続的に減少すると、メンバーはダウングレードされます。詳細はメンバーのレベルを参照してください。 3. クラブポイントが0になると、メンバーは自動的にクラブを退会します。",
    lang20: "メンバーの特権",
    lang21: "その他",
    lang22:
      "クラブに偽のアカウント、チート、または地元の法律や規制に違反する名前やカバーがある場合、FIREFLYプラットフォームはクラブを変更または削除する権利を有します。",
    lang23: "クラブレベル",
    lang24: "アップグレードに必要なポイント",
    lang25: "Daily bonus",
    lang26: "クラブポイントの上限",
    lang27: "減衰",
    lang28: "特権",
    lang29: "説明",
    lang30: "クラブネームプレート",
    lang31: "C.by クリエイターのライブ放送ルームでの特別レベル識別",
    lang33: "C.byクリエイターのライブ放送ルームでの限定プレゼント",
    lang34: "専用チャットボックス",
    lang35: "C.byクリエイターのライブ放送ルームの専用チャットボックス",
    lang36: "クラブの宝箱",
    lang37: "クラブ宝箱の特権は、C.byの生放送ルームで獲得できます",
    lang38: "Daily bonus",
    lang39:
      "C.by クリエイターのライブ放送ルームで毎日のタスクを完了すると、ギフトパックを受け取ることができます。",
    lang40: "メンバーチャット",
    lang41:
      "クラブのメンバー全員とプライベートメッセージで親密度制限なしでチャット",
    lang42: "リフレッシュ",
    lang43: "カスタマーサービス",
    lang44: "ページを閉じる",
    lang45: "クラブ",
    lang46: "Club",
    lang47:
      "クラブはプレイヤーと領主が共に築く専属コミュニティです。クラブに加入して評判を貢献し、クラブ同士で栄誉を競い合い、ランキング限定報酬を獲得しましょう！",
    lang48: "所属クラブ",
    lang49:
      "各プレイヤーが所属クラブに設定できるのは最大1つです。設定すると、そのクラブでの役割が「メンバー」に変わります。設定後、栄誉による評判（ランキング優勝、夜間オーディション優勝など）やPKルームのゲームでの勝利は、自動的に所属クラブへの貢献となります。",
    lang50: "クラブへの加入・脱退",
    lang51:
      "領主に「塵心鐘」のギフトを贈ると、その領主のクラブに加入できます。ギフトによる加入後の役割は「ゲスト」です。プレイヤーは自由にクラブを脱退できます。",
    lang52: "評判",
    lang53:
      "評判はクラブ間の競争の中心です。クラブ内の全員が、クラブ任務の達成、ランキングイベントの優勝争い、ゲームへの参加と勝利を通じてクラブに評判を貢献します。",
    lang54: "クラブ報酬",
    lang55:
      "クラブが競争で獲得した報酬は会長に配布されます。会長が設定されていないクラブは、クラブ報酬を受け取れません。",
    lang56: "クラブランキングへの参加",
    ranked: "ランクイン",
    lang57:
      "以下の条件を満たすクラブは、FIREFLY Clubのクラブランキングに参加できます。",
    lang58: "クラブ名を変更する",
    lang59: "クラブのカバーを変更する",
    lang60: "会長を設定する",
    lang61:
      "条件を満たしていないクラブも、プレイヤーの加入や評判の蓄積は通常どおり行えますが、ランキングには参加できません。",
    lang62: "クラブの役割",
    lang63: "Club Role",
    lang64: "領主",
    lang65:
      "領主はクラブの創設者であり、クラブと深く結びついています。クラブの管理・編集権限を持ち、会長を設定できます。",
    lang66: "会長",
    lang67:
      "領主によって任命され、クラブの管理・編集権限を持ちます。クラブのPKルームを開くことができます。",
    lang68:
      "<span class='highlight-text'>クラブ報酬：</span>クラブに配布される報酬はすべて会長に送られます。会長が設定されていないクラブは、クラブ報酬を受け取れません。",
    lang69: "メンバー",
    lang70:
      "クラブに加入し、そのクラブを「所属クラブ」に設定したプレイヤーです。栄誉やゲームで獲得した評判報酬は、自動的に所属クラブに貢献されます。",
    lang71: "ゲスト",
    lang72:
      "クラブに加入していますが、そのクラブを「所属クラブ」に設定していないプレイヤーです。",
    lang73: "王者クラブ",
    lang74:
      "FIREFLYの週間クラブランキングで優勝したクラブは、翌週の「王者クラブ」になります。その期間中、ゲストは王者クラブを所属クラブに設定できません。王者クラブのメンバーは、すべての配信ルームでクラブ名が表示されます。",
    lang75: "その他",
  },

  /* 极速狂飙 */
  kingOfSpeed: {
    lang1: "ゲームルール",
    lang2: "ゲーム説明",
    lang3:
      "1. サイコロを振る：「サイコロを振る」をクリックするたびに1000DEWかかります。サイコロを振ると、チームの車にボーナスが付与されます。",
    lang4:
      "2. サイコロ確率：6つの効果のそれぞれが出る確率は同じですが、6つの面それぞれに付与されるボーナス効果は異なります。",
    lang5:
      "3. ゲーム結果：PK時間終了時、距離の長いチームが勝利、距離の短いチームが敗北となります。両チームの距離が同じ場合は引き分けとなります。",
    lang6: "車の説明",
    lang7:
      "1. 車の要件：ゲーム開始時に配信者が車を所有していない場合、現在のチームの車は編成できません。",
    lang8: "Qiレベルの説明",
    lang9:
      "1. レベルアップ：プレイヤー同士が交流することで、配信者の人気度が上がります。人気度はチームのQiレベルを上げるために使用されます。Qiレベルが高いほど、ダイスボーナス効果が強くなります。",
    lang10: "2. Qiレベル要件：",
    lang11: "ダイスレベル",
    lang12: "人気",
    lang13: "DEWプールの説明",
    lang14:
      "1. DEWプール：両プレイヤーが振ったサイコロの目から出たDEWはDEWプールに蓄積されます。ゲーム終了時、勝利チームはプール内のすべてのDEWを報酬として受け取ります。引き分けの場合は、両チームのプレイヤーがDEWプールから報酬を受け取ります。",
    lang15:
      "2. 報酬の分配：報酬は、勝利チームの各プレイヤーのダイスの出目に対するDEWの割合に基づいて分配されます。ゲームに参加するためにダイスを振らなかったプレイヤーは、Dewプールの報酬分配には参加しません。",
    lang16:
      "3. サービス料：プレイヤーはDEWプールから報酬を受け取ります。プラットフォームは4%のサービス料を請求します。",
    lang17: "ゲーム開発に関する注意事項",
    lang18:
      "1. プレイヤーは2025年10月23日午後12時から2025年12月17日午前0時まで、ゲーム内PKを通じてキング・オブ・スピードに参加できます。",
    lang19: "予防",
    lang20: "1. イベント中のすべての時間はサーバー時間に基づいています。",
    lang21:
      "2. ゲームの公平性を確保するため、プラットフォームはネットワークの問題、不正行為、その他の不正行為など、不可抗力の要因によりゲームに不規則性が生じた場合、調整または中断する権利を留保します。",
    lang22:
      "3. このゲームは娯楽目的のみ。プレイヤー間または配信者間のオフライン取引は固く禁じられています。詐欺や不正な利益を得ようとする行為にはご注意ください。",
    lang23:
      "4. プラットフォームは、個人のネットワークまたはデバイスの問題によるゲーム損失について責任を負いません。",
    lang24: "5. ゲームの最終的な解釈権はプラットフォームに帰属します。",
    lang25: "PKゲーム記録",
    lang26: "PK時間",
    lang27: "サイコロを振る",
    lang28: "PKチーム",
    lang29: "距離",
    lang30: "結果",
    lang31: "読み込み中...",
    lang32: "記録なし",
    lang33: "PK記録なし",
    lang34: "相手は車を持っていません。",
    lang35: "青チームは車を持っていません",
    lang36: "レッドチームに車両がありません。",
    lang37: "速度制限",
    lang38: "速度",
    lang39: "配信者はゲームに参加するには車を用意する必要があります。",
    lang40: "出発",
    lang41: "Tips",
    lang42: "現在車を所有していないため、PKゲームに参加できません",
    lang43: "移動",
    lang44: "DEWプール",
    lang45: "自分のチーム",
    lang46: "反対側",
    lang47: "投げる",
    lang48: "私のロール：",
    lang49: "賞品情報",
    lang50: "1. DEWプール：",
    lang51:
      "両プレイヤーが振ったサイコロの目から得られたDEWは、DEWプールに追加されます。ゲーム終了時に、勝利チームはDEWプール内のすべてのDEWを報酬として受け取ります。同点の場合は、両プレイヤーとも",
    lang52: "2. 報酬分配：",
    lang53:
      "報酬は、勝利チームの各プレイヤーのダイスの出目に対するDEWの割合に基づいて分配されます。ゲームに参加するためにダイスを振らなかったプレイヤーは、DEWプールの報酬分配には参加しません。",
    lang54: "3. サービス料：",
    lang55:
      "プレイヤーはDEWプールから報酬を受け取ります。プラットフォームは4%のサービス手数料を請求します。",
    lang56: "決定する",
    lang57: "スピードアップ",
    lang58: "シールド",
    lang59: "チャージ",
    lang60: "レッドチーム",
    lang61: "ブルーチーム",
    lang62: "レーシングカーの詳細",
    lang63: "発動中",
    lang64: "アクティブ化されていません",
    lang65: "秒",
    lang66: "速度2倍、継続",
    lang67: "保護中",
    lang68: "保護なし",
    lang69: "シールドは、マイナス効果に対する抵抗を1回付与します。",
    lang70: "(干渉、速度制限)",
    lang71: "続き",
    lang72: "発動中",
    lang73: "アクティブ化されていません",
    lang74: "チャージ値が満タンになると、車の速度は3倍になり、持続時間は",
    lang75: "スピードブースト持続時間",
    lang76: "スピードアップ",
    lang77: "ターボモード：",
    lang78: "シールドの持続時間",
    lang79: "妨害",
    lang80: "妨害モード：",
    lang81: "速度制限",
    lang82: "車獲得",
    lang83:
      "チャージ値：チャージ値が100%に達すると、チャージモードが発動します。チャージ速度は3倍になり、持続時間は",
    lang84: "時間切れ後に終了します。",
    lang85: "チャージモード",
    lang86: "料金リセット",
    lang87: "車はスピードブーストを受けます。",
    lang88: "継続",
    lang89: "時間切れ後、速度は回復します。",
    lang90: "レーシングカー獲得",
    lang91: "ボーナス",
    lang92: "速度",
    lang93: "継続",
    lang94: "1回抵抗",
    lang95: "マイナス効果",
    lang96:
      "複数のシールドボーナスが付与された場合、シールドはスタックされます。タイマーが切れるか、耐性が適用されると、シールドスタックは1減少します。",
    lang97: "相手をターゲットとした妨害効果を使用します。",
    lang98: "妨害",
    lang99: "発動後、車両の通常速度が低下します。",
    lang100:
      "速度制限効果を使用して相手チームに減速サインを送り、車両の速度を低下させます。",
    lang101: "妨害",
    lang102: "速度制限",
    lang103: "サイコロを振る",
    lang104: "サイコロを振ってボーナスを獲得します。",
    lang105: "スピードアップ！一緒に全力疾走！",
    lang106:
      "スローガンがコピーされました。入力ボックスに貼り付けて送信してください！",
    lang107: "コピー失敗",
    lang108: "レースゲームに参加する",
    lang110: "配信者は車を所有しています。",
    lang111: "達成",
    lang112: "未達成",
    lang113: "PKチームに参加",
    lang115: "クリックして車を送信",
    lang116: "チームスローガンを送信するにはクリックしてください",
    lang117:
      "現在のゲームはアクティブではないため、サイコロを振ることはできません。",
    lang118: "配信者はサイコロを振ることができません。",
    lang119: "スピードラッシュ、勝者総取り！",
    lang120: "ゲームは開始されていません",
    lang121:
      "[キング・オブ・スピード]は有効化されていないため、プレイできません。",
    lang122: "レーシングカーがシールド付加を獲得",
    lang123: "車がない",
    lang124: "リードしている",
    lang125: "立ち後れる",
  },

  /* 上播助手 */
  videoAssistant: {
    lang1: "ライブアシスタント",
    lang2:
      "プレイヤーをライブアシスタントとして連携すると、受け取った FIRE の割り当てが相手に付与されます。",
    lang3: "連携されたライブアシスタント",
    lang4: "連携したプレイヤーを確認するには、ID を入力してください。",
    lang5: "バインドするプレイヤーIDを入力してください",
    lang6: "次へ",
    lang7: "FIRE シェア率",
    lang8: "バインド手順",
    lang9:
      "ライブアシスタントをバインドすると、ライブアシスタントはあなたが獲得したFIREの一部を受け取ります。ギフトで獲得したFIREは、あなたが設定したFIREの分配率に従ってライブアシスタントに送られます。",
    lang10: "確認",
    lang11: "ライブアシスタントをバインド",
    lang12: "バインドを確定しますか？",
    lang13: "あなたのライブアシスタント",
    lang14: "キャンセル",
    lang15: "バインディングに成功しました",
    lang16: "バインドに失敗しました",
    lang17: "バインド解除に成功しました",
    lang18: "連携解除に失敗しました",
    lang19:
      "プレイヤーをライブアシスタントとして連携すると、受け取った FIRE の割り当てが相手に付与されます。",
    lang20: "私のライブアシスタント",
    lang21: "バインド解除",
    lang22: "確認待ち",
    lang23: "ライブアシスタントのバインド解除",
    lang24:
      "ライブアシスタントとの連携を解除するには、相手からの確認が必要です。連携を解除しますか？",
    lang25: "ライブアシスタントですか？",
    lang26: "バインド解除が拒否されました",
    lang27: "バインド解除が拒否されました",
    lang28: "ライブアシスタント設定",
    lang29: "新規FIREs",
    lang30:
      "相手があなたのライブアシスタントステータスの連携を解除しました。確認が必要です。",
    lang31: "バインド解除リクエスト",
    lang32:
      "ライブアシスタントアカウントのバインドを解除するには、逆の手順を適用しました。ご確認ください。",
    lang33: "拒否",
    lang34: "私をライブアシスタントとして連携した配信者の一覧",
    lang35: "まだストリーマーをバインドしていません",
    lang36: "ライブアシスタントのバインド解除",
    lang37: "連携を解除しますか？",
    lang38: "あなたのライブアシスタント関係は？",
    lang39: "ユーザーは禁止されました。",
    lang40: "入力したIDの検索に失敗しました。",
  },

  /* 夜间选秀 */
  nightDraft: {
    lang2: "ライブ状況",
    lang3: "歴史的",
    lang4: "本日の参加権を棄権しました。",
    lang5: "本日の参加資格を放棄できませんでした",
    lang6: "参加資格の放棄",
    lang7: "自分のランキング",
    lang8: "勝利",
    lang9: "コンテスト手順",
    lang10:
      "準決勝/決勝に進出する放送者は、指定された開始時間にライブ配信を継続し、かつ他のPK戦に参加していない必要があります。その後、システムはそれぞれの放送者間でPK戦を自動的に開始します。",
    lang11: "準決勝",
    lang12: "5本勝負で勝利した配信者が決勝に進出します",
    lang13: "オーディションNo.1 VS オーディションNo.4",
    lang14: "オーディションNo.2 VS オーディションNo.3",
    lang15: "決勝",
    lang16:
      "5本勝負で勝利した配信者が、その日の「グローナイト・ショーダウン」チャンピオンとなります。",
    lang17: "準決勝勝者",
    lang18:
      "注：準決勝/決勝の参加要件を満たしているにもかかわらず参加できない場合は、毎日20:30までにこちらをクリックしてください。",
    lang20:
      "試合を欠席した場合、今後15日間「グローナイトショーダウン」イベントに参加できなくなります。",
    lang22:
      "試合を棄権するとオーディションランキングから外れますが、翌日に資格が回復します。",
    lang23: "本日の参加権を棄権しますか？",
    lang24: "ファイアフライグローナイト対決イベント",
    lang25: "キャンセル",
    lang26: "確認",
    lang27: "勝利",
    lang28: "DNF",
    lang29: "過去の記録はありません",
    lang30: "「グローナイト・ショーダウン」に参加しましょう",
    lang31:
      "FIREFLY V54.0以上を使用してPK（「人気PK」と「ゲームPK」を含む）を開始した配信者は、グローナイト・ショーダウンイベントに参加できます。",
    lang32: "オーディション",
    lang33: "時間：毎日20:30 - 翌日20:30",
    lang34:
      "ルール：「新星認定」を受けたことのある配信者とPKを開始すると、当日のオーディションランキングに参加できます。ランキングは、配信者が当日に完了したすべてのPK戦の人気値の合計に基づいて決定されます。",
    lang35:
      "進出：毎日20:30までにオーディションランキングの上位4名が準決勝に進出します。",
    lang36:
      "出場資格の放棄：準決勝/決勝の指定時間内にライブ配信できない場合、オーディション期間中に棄権を選択できます。次点の順位の配信者が出場権を獲得します。",
    lang37: "準決勝",
    lang38: "時間：毎日21:00 / 21:20",
    lang39:
      "ルール：指定された時間に、準決勝の2名の配信者間で自動的にPK戦が開始されます。PKルールは「人気PK」で、ベスト・オブ・5形式です。配信者はこの間、ライブ配信を続けなければなりません。",
    lang40: "進出：勝者は決勝に進出します。",
    lang41:
      "出場資格の放棄：準決勝開始時にライブ配信を行っていない配信者は、棄権したものとみなされます。ランキング報酬は受け取れず、今後15日間「グローナイトショーダウン」への参加資格を失います。",
    lang42: "毎日の予選終了後、システムがランダム抽選で決定します",
    lang43: "毎日の予選終了後、システムがランダム抽選で決定します",
    lang44:
      "準決勝の敗者は、その日の人気度に基づいて3位または4位にランク付けされます。",
    lang45: "決勝",
    lang46: "時間：毎日22:00",
    lang47:
      "ルール：システムは指定された時間に、決勝進出者2名の間でPK戦を自動的に開始します。PKルールは「人気PK」で、5本先取の形式です。この間、放送者はライブ配信を継続する必要があります。",
    lang48:
      "進出：勝者はその日の「グローナイトショーダウン」チャンピオンに輝きます。",
    lang49:
      "参加資格の放棄：決勝戦開始時にライブ配信を行っていない配信者は、参加資格を放棄したものとみなされます。ランキング報酬は付与されず、今後15日間「グローナイトショーダウン」に参加できなくなります。",
    lang50:
      "決勝戦の勝者はその日のチャンピオン、敗者はその日のNo.2となります。",
    lang51: "褒美",
    lang52: "プレイヤーDEW報酬：",
    lang53: "準決勝1：優勝チームは決勝進出権を分け合います。",
    lang54: "準決勝2：勝者は勝ち点を分け合います",
    lang55: "決勝：優勝チームは決勝進出権を分け合います。",
    lang56: "配信者ポイント報酬：",
    lang57:
      "準決勝/決勝に参加した配信者の皆様は、優勝者決定後、上位4名に「ライブ配信報酬」のポイントが付与されます。棄権した配信者にはポイント報酬は付与されません。具体的なポイントについては、こちらをご覧ください。",
    lang58: "生放送報酬 >",
    lang59: "予防",
    lang60: "1. イベントは女性キャスターに限定されます",
    lang61:
      "2. アクティビティへの参加資格が制限されている期間中は、すべてのアクティビティデータが無効となり、制限解除後に再度取得する必要があります。",
    lang62:
      "3. ストリーマーはプレイヤーと積極的に交流する必要があります。プラットフォームは、「ストリーマー規約」に違反する、またはイベントのバランスを乱す行為（顔出し配信、低品質配信、ブラックスクリーン、AFK配信、ゲームプレイ中の配信、テレビ視聴、PvPの結果への共謀、消極的なプレイなどを含むがこれらに限定されない）を行ったストリーマーを失格とし、アクティビティポイントを剥奪する権利を留保します。上記のルールに違反したストリーマーは、プラットフォームから「レッドカードペナルティ」の対象となります。",
    lang63:
      "4. プラットフォームは、本イベントに関する最終的な決定権を留保します。",
    lang64: "オーディション中",
    lang65: "20:30 - 翌日20:30",
    lang66:
      "配信者とPKを開始すると、オーディションランキングに参加できます。オーディションランキングでは、当日の有効なPK対戦で獲得した人気度が累計され、上位4名が準決勝に進出します。",
    lang67: "プロモーションゾーン",
    lang68: "オーディション記録は利用できません。",
    lang69:
      "「FIREFLY」グローナイト・ショーダウン決勝への出場権を獲得しました。",
    lang70: "毎日21:00～23:00、PK戦の勝者にはDEW報酬が贈られます",
    lang71: "決勝進出者未定",
    lang72: "準決勝の配信者はまだ決定していません",
    lang74: "オーディション 1",
    lang75: "オーディション 2",
    lang76: "オーディション 3",
    lang77: "オーディション 4",
    lang78: "リマインダー >",
    lang79: "優勝チーム報酬",
    lang80: "ベスト・オブ・5",
    lang81: "ランキングはロックされています",
    lang82: "まだランキングはありません",
    lang83: "「FIREFLY」蛍光夜オーディション1の準決勝に出場決定",
    lang84: "「FIREFLY」蛍光夜オーディション2の準決勝に出場決定",
    lang85: "さらに読み込み中...",
    lang86: "下にスクロールしてさらに読み込む",
    lang87: "今のところそれ以上の情報はありません。",
    lang88: "レッドカードのペナルティ:",
    lang89:
      "a. 当日の「ナイトタイムグロウショー」特典の受け取り資格を失効します。",
    lang90:
      "b. 今後5日間は「ネオンナイトオーディション」イベントへの参加が禁止されます。",
    lang91: "報酬",
    lang92:
      "毎日の「蛍光ナイトオーディション」で上位4名に入ったストリーマーは報酬を受け取ることができます",
    lang93: "チャンピオン",
    lang94: "NO.2",
    lang95: "NO.3/NO.4",
    lang96: "その他の順位",
    lang97: "報酬なし",
    lang98: "受け取る",
    lang99: "蛍光ナイトオーディションの報酬を獲得していません",
    lang100: "受け取り済み",
    lang101: "蛍光ナイトオーディションの報酬を受け取りました",
    lang102: "受け取り成功",
    lang103: "ストリーマーはジェム報酬を受け取ることができます：",
    lang104: "チャンピオン：",
    lang105: "2位：",
    lang106: "3位/4位：",
    lang107: "決勝報酬",
    lang108: "結果",
    lang109: "報酬",
    lang110: "勝利",
    lang111: "敗北",
    lang112: "未完走",
    lang123: "報酬なし",
    lang124: "準決勝報酬",
    lang125: "予選報酬",
    lang126: "決勝報酬",
    lang127:
      "「蛍光ナイトオーディション」決勝に参加し、決勝終了後に受け取り可能",
    lang128: "準決勝報酬",
    lang129:
      "「蛍光ナイトオーディション」準決勝に参加し、決勝終了後に受け取り可能",
    lang130: "予選報酬",
    lang131:
      "「ナイトオーディション決勝」で上位8名に入ると受け取り可能。毎日21:00に配布",
    lang132: "未開始",
    lang133: "PK中",
    lang134: "終了",
    lang135: "現在受け取れる報酬はありません",
    lang136: "すでに報酬を受け取りました",
    lang137: "蛍光ナイトオーディションPKに参加し、毎日",
    lang138: "受け取る",
    lang139: "受け取り済み",
    lang140: "すべて受け取る",
    lang141: "マイ報酬",
    lang142: "中",
    lang143: "NO.1-NO.4",
    lang144: "予選順位",
    lang145: "NO.5-NO.8",
    lang146: "報酬なし",
    lang147: "その他の順位",
    lang148: "未参加",
    lang149: "報酬エリア",
    lang150: "アプリをV57.0以上に更新して報酬を受け取ってください！",
    lang151: "試合結果",
    lang152: "本日のナイトオーディションの最終順位確定後に受け取れます",
    lang153: "予選Top4",
  },

  /* firstLove */
  firstLove: {
    lang1: "FirstLove",
    lang2:
      "7日以内に登録し、「初回チャージギフトパック」チャージイベントを完了した新規プレイヤーには、「FirstLove」ギフト報酬が贈られます。「FirstLove」ギフトを送ると、ストリーマーはFirstLoveに紐付けられ、ライブ配信でのコメントに特別なタグが付きます。プレイヤーは1つのFirstLoveアカウントのみ紐付けることができます。",
    lang3: "初回チャージギフトパックへの応募",
    lang4: "ギフトの送信",
    lang5: "FirstLove初礼ランキング",
    lang6:
      "FirstLove初礼ランキングは、ライバーが受け取ったFirstLove初礼の数に基づいて順位付けされます。受け取った数が多いほど順位が高くなります。複数のライバーが同じ数のFirstLoveを受け取った場合は、",
    lang7: "その数に先に到達したライバーの順位が上になります。",
  },

  /* 迎新奖励 */
  newsRewards: {
    lang1: "毎日の報酬",
    lang2: "報酬記録",
    lang3: "【ウェルカムタスク】",
    lang4: "ポイント",
    lang5:
      "「ウェルカムPK」イベントを完了してください。1日あたり最大6000ポイントを獲得できます。",
    lang6: "ウェルカムPK",
    lang7:
      "PKの結果に基づき、「ウェルカムPK」（1時間）を完了するごとにポイントを獲得できます。",
    lang8: "イベント",
    lang9: "獲得済み",
    lang10: "受け取り",
    lang11: "獲得済み",
    lang12: "ポイント交換",
    lang13: "マイポイント",
    lang14: "報酬",
    lang15: "ステージ",
    lang16: "累積ポイント到達",
    lang19: "ポイント報酬",
    lang20: "ウェルカム報酬",
    lang21:
      "毎日開催されるウェルカムPKイベントでは、専用のトラフィックサポートが受けられます。",
    lang25: "いいね！",
    lang26: "データがありません",
    lang27: "ウェルカム報酬ルール",
    lang29:
      "新規ストリーマーがPKを開始する際、「ウェルカムPK」を選択し、マッチメイキングを開始します。ウェルカムPKは、両ストリーマーが獲得した「いいね！」の数を競います。",
    lang30: "いいね！の獲得方法：",
    lang31: "新規プレイヤー限定ギフトを受け取ろう",
    lang32: "限定ギフトの説明：",
    lang33: "ギフト名：",
    lang34: "入手方法：",
    lang35:
      "新規登録プレイヤーは、48時間有効なこのギフトを無料で受け取ります。ライブ配信ルームで「新規登録ギフト」をクリックすると、ギフトを受け取ることができます。",
    lang36: "いいね！",
    lang37: "FirstLove",
    lang38:
      "新規プレイヤーが登録後7日以内に「初回リチャージギフトパック」リチャージイベントを完了すると、「FirstLove」ギフト報酬が付与されます。",
    lang39: "本日のポイントは既に獲得済みです。",
    lang40:
      "報酬獲得条件を満たしていない場合、ポイントを獲得することはできません。",
    lang41: "ウェルカム報酬ポイントを獲得する",
    lang42: "ウェルカムユーザーサポート",
    lang43:
      "「ウェルカムPK」を有効にすると、ウェルカムトラフィックサポートが付与されます。ウェルカムPK期間中に新規登録されたプレイヤーは、自動的に「ウェルカムPK」ライブ配信ルームにプッシュされます。",
    lang44: "ポイント獲得",
    lang45:
      "「デイリー報酬」を完了してポイントを獲得しましょう。ポイントを貯めてレベルアップすると、Firefly報酬を受け取ることができます。",
    lang46: "注意事項",
    lang47: "1. このイベントは女性ストリーマーのみが参加できます。",
    lang48:
      "3. 報酬を受け取れるのはデバイス1台につき1アカウントのみです。複数のアカウントで報酬を受け取った場合、失格となり、資格回復はされません。",
    lang49:
      "4. 参加制限期間中は、すべてのイベントデータが無効となり、制限解除後に再度取得する必要があります。",
    lang50:
      "5. デイリー報酬ポイントは手動で獲得する必要があります。2025年12月3日正午までに獲得してください。期限を過ぎた場合、再獲得はできません。",
    lang51:
      "6. 招待者に既にリンクされているアカウントは、ライブ配信やポイント獲得のためにサブアカウントを作成することはできません。発覚した場合、すべてのアカウントは失格となり、資格は回復されません。",
    lang52:
      "7. 招待者がいないアカウントはアカウント制限の対象外となり、参加資格を得る場合がありますが、報酬イベントに参加できるアカウントは1アカウントのみです。",
    lang53:
      "8. ストリーマーはプレイヤーと積極的に交流する必要があります。 「ストリーマーライブ配信規約」に違反する行為、またはイベントのバランスを乱す行為があった場合、プラットフォームはストリーマーを失格とし、イベントポイントを剥奪する権利を有します（顔面ぶら下がり、低画質配信、ブラックスクリーン、AFK、ゲームプレイのストリーミング、テレビ視聴などを含むがこれらに限定されない）。",
    lang54: "9. このイベントの最終的な解釈権はプラットフォームに帰属します。",
    lang55: "2. イベント時間は2分ごとに集計されます。",
    lang57: "勝利",
    lang58: "抽選",
    lang59: "Lose",
    lang60: "報酬ステージ1",
    lang61: "報酬ステージ2",
    lang62: "報酬ステージ3",
    lang63: "報酬ステージ4",
    lang64: "報酬レベル",
    lang65: "ポイント獲得条件",
    lang66: "獲得ポイント",
    lang67: "獲得可能",
    lang68: "ポイント交換完了",
    lang69: "のように",
    lang70: "賞賛",
    lang71: "本日のポイントを既に受け取りました",
  } /* 合作联系 */,

  cooperate: {
    lang1: "メッセージが正常に送信されました！",
    lang2: "あなたのニックネーム",
    lang3: "連絡メディア：",
    lang4: "連絡先：",
    lang5:
      "協力メッセージとFIREFLYの成長に関するご意見をありがとうございます。スタッフからご連絡いたします。残された連絡先にご注意ください。",
    lang6: "配信者の協力紹介",
    lang7: "エンボイのホームページを見る",
    lang8: "ホームに戻る",
    lang9:
      "エンボイになったFIREFLYの配信者、ユーザーの招待者、またはギルドメンバーは、招待した相手と文通関係を築き、長期的な報酬を得ることができます。優秀なエンボイはコミュニティ内の特権も自動的に獲得します。",
    lang10: "連絡先を残してください",
    lang11: "別の連絡先を残してください（任意）",
    lang12: "FIREFLYへのメッセージ",
    lang13: "FIREFLYへのメッセージを入力してください",
    lang14: "送信を確認する",
    lang15: "連絡メディアを選択",
    lang16: "Wechat",
    lang17: "配信者の協力",
    lang18: "独立した配信者が自分でFIREFLYに参加する",
    lang19: "エンボイの協力",
    lang20: "ギルドとしてFIREFLYに参加する",
    lang21: "ビジネス協力",
    lang22: "プロモーションとメディア",
    lang23: "プレイヤーの意見",
    lang24: "FIREFLYプレイヤー意見提出チャネル",
    lang25: "協力の連絡",
    lang26: "FIREFLY IDを入力してください",
    lang27: "Whatsapp IDを入力してください",
    lang28: "Telegram IDを入力してください",
    lang29: "Facebook IDを入力してください",
    lang30: "メールアドレスを入力してください",
    lang31: "Wechatを入力してください",
    lang32: "Lineを入力してください",
    lang33: "後でもう一度お試しください",
    lang34: "ニックネームを入力してください",
    lang35: "連絡先を入力してください",
    lang36: "メッセージを入力してください",
  },
  premiumNumberCommitLetter: {
    lang1: "特別番号有効化誓約書",
    lang2: "親愛なる ",
    lang3: "元ID：",
    lang4: "申請された特別番号 ",
    lang5:
      "はまもなく有効化されます。プラットフォームの秩序とアカウント安全を維持するため、以下の約定をよく読み同意してください。",
    lang6:
      "取得された特別番号はFIREFLYコミュニティにおける希少で再生不能な資源であり、この種のアカウントの譲渡はコミュニティの安定と構造に負の影響を与える可能性があります。",
    lang7: "【誓約約定】",
    lang8:
      "1.本番号は本人のみが使用し、販売・賃貸・贈与・譲渡などいかなる形式でも第三者に提供しません。",
    lang9:
      "2.上記に違反した場合、プラットフォームは当該番号を回収する権利を有し、元のアカウントに対して停止・権限降格等の制限を行う場合があります。",
    lang10:
      "3.プラットフォームのユーザー規約および関連法令を遵守し、違反・違法行為に本番号を使用しません。",
    lang11:
      "本誓約は署名後ただちに拘束力を有します。ご理解とご協力に感謝します。",
    lang12: "同意しない",
    lang13: "同意する",
    lang14: "ユーザーは同意しました",
    lang15: "同意時刻：",
    lang16: "移行申請を提出しました",
    lang17:
      "具体的な移行時間は専任カスタマーサービスよりご連絡します。ご理解とご支援に感謝します。",
    lang18: "了解しました",
    lang19: "申請は正常に送信されました。ご理解とご支援に感謝します。",
    lang20: "更新",
    lang21: "カスタマーサービス",
    lang22: "ページを閉じる",
    lang23: "その他",
  },
  vipUpPublicNotice: {
    lang1: "より高貴で専属の体験をお届けするため、",
    lang2: "2026/8/4",
    lang3: "に新しいVIP等級システムを正式リリースします",
    lang4:
      "本調整では一部VIP等級の必要富豪値を再編し、より豊富で魅力的な特権を追加します。主な変更点は以下の通りです。",
    lang5: "新システム公開後、既存の富豪等級は",
    lang6: "富豪値に基づき自動的に継承され",
    lang7: "新システムの対応するVIP等級になります。",
    lang8:
      "例：以前の等級がVIP43（富豪値3254120）の場合、VIP45に継承され、富豪値は変わらず、対応するVIP特権を獲得します。",
    lang9: "特権タイプ",
    lang10: "具体的特権",
    lang11: "解放等級",
    lang12: "身分非表示",
    lang13: "ステルス",
    lang14: "管理免除",
    lang15: "キック・ミュート防止",
    lang16: "パーソナル乗り物",
    lang17: "専用カスタム乗り物",
    lang18: "特別番号体系",
    lang19: "6桁 / 5桁 / 4桁の特別番号",
    lang20: "弾幕カラー",
    lang21: "3色 / 5色カスタマイズ",
    lang22: "専属サービス",
    lang23: "専属カスタマーサービス",
    lang24: "チャージ特典",
    lang25: "専属チャネル",
    lang26: "名刺美化",
    lang27: "静的/動的プロフィール背景",
    lang28: "カスタムギフト",
    lang29: "中級（5秒）/上級（10秒）ギフト",
    lang30: "全サイト通知",
    lang31: "オンライン全体通知",
    lang32: "プラットフォームの発展に伴い、",
    lang33: "VIP特権とサービス体験を継続的に改善します",
    lang34:
      "。特権規則や権益の変更がある場合は、速やかにお知らせしますのでご留意ください。",
    lang35: "最終解釈権はFireflyに帰属します",
  },
  // Ludo
  ludo: {
    clubPkRoom: "{club}のPKルーム",
    lang1: "ルームを開く",
    lang2: "クイック参加",
    lang3: "入場",
    lang4: "待機中",
    lang5: "現在 Ludo PK ルームはありません",
    lang6: "プレイモード",
    lang7: "デフォルトクラブ",
    lang8: "クラシック",
    lang9: "制限なし",
    lang10: "戦績",
    lang11: "ランキング",
    lang12: "入場露水",
    lang13: "プレイ情報",
    lang16: "入場露水を支払ってLudo PKに参加",
    lang17: "プレイヤー数",
    lang18: "勝利報酬",
    lang19: "名声",
    lang20: "マイアイテム",
    lang21: "駒",
    lang22: "盤面",
    lang23: "LUDOゲームで使用する駒アイテムを選択してください。",
    lang24:
      "LUDOゲームでクラブPKルームに使用する盤面アイテムを選択してください。",
    lang25: "時間バッジ",
    lang26: "選択済み",
    lang27: "デフォルト",
    lang28: "アイテムを選択してください",
    lang31: "使用",
    lang32: "使用するアイテムをタップして選択",
    lang33:
      "タップして使用すると、次のLUDOゲームでこの盤面アイテムが適用されます",
    lang34:
      "タップして使用すると、次のLUDOゲームでこの駒アイテムが適用されます",
    lang35: "使用中です",
    lang36: "使用するアイテムを選択してください",
    lang37: "使用成功、次のLUDOゲームで有効になります",
    lang38: "日",
    lang39: "時間",
    lang40: "分",
    lang42: "現在LUDO PK記録はありません",
    lang43: "ゲーム詳細",
    lang45: "ルーム料金",
    lang46: "時間",
    lang47: "露水",
    lang49: "日付",
    lang50: "合計",
    lang51: "プレイヤー头像",
    lang52: "順位",
    lang53: "1位",
    lang54: "2位",
    lang55: "3位",
    lang56: "4位",
    lang57: "読み込み中...",
    lang58: "カスタマーサービス",
    lang59: "勝",
    lang60: "負",
    lang61: "引き分け",
    lang62: "プレイ説明",
    lang63: "ゲームルール",
    lang64: "プレイヤー数",
    lang66: "勝敗判定",
    lang68: "クラブ名声",
    lang69: "ゲーム参加",
    lang70: "途中参加",
    lang72: "離陸",
    lang73: "三連六",
    lang74: "移動",
    lang75: "重なり駒",
    lang76: "駒を食べる",
    lang77: "安全地帯",
    lang78: "2-4人",
    lang79:
      "クラシック: プレイヤーの駒はスタート地点から盤面を一周してゴールに到達する必要があります。すべての駒がゴールに到達するとゲーム完了です。早く完了するほど順位が高くなります。",
    lang80:
      "プレイモードに応じて、先にゲームを完了したプレイヤーほど順位が高くなります。例えば最初に完了したプレイヤーがその試合の1位となり、以下同様です。",
    lang81: "ゲーム終了後、順位に応じて露水と名声報酬を獲得できます。",
    lang82:
      "参加中のクラブルームでゲームに勝利した場合、そのゲーム順位に応じてクラブ内名声が増加します。",
    lang83: "ルームオーナーが設定した入場露水を支払うとゲームに参加できます。",
    lang84:
      "すでに始まっているゲームでも、入場露水を支払えば途中からLudo PKに参加できます。",
    lang85:
      "サイコロで6を出さないと、駒は基地からスタートマスへ離陸できません。",
    lang86:
      "同一ターン内で6を3回出すと三連六が発動し、そのターンはスキップされます。",
    lang87: "プレイヤーはサイコロを振って出た目に応じた歩数だけ駒を進めます。",
    lang88:
      "同じプレイヤーの駒が同じ位置に止まると重なり駒になります。食べられると重なった駒はすべて基地に戻されます。",
    lang89:
      "移動後に他プレイヤーの駒があるマスに止まった場合、そのプレイヤーの駒はすべて基地に戻され、再び離陸しないと行動できません。",
    lang90:
      "盤面上のスタート地点と盾付きマスは安全地帯で、駒は食べられません。異なるプレイヤーの駒も同時にそこへ止まれます。",
    lang91:
      "各ゲームでは固定数量の露水がルーム料金として徴収されます。ルーム料金の金額は入場露水数に基づいて決まり、プレイヤー数とは関係ありません。ゲーム終了後に報酬露水を精算する際、システムは先にルーム料金を自動控除してから勝者への報酬露水を配布します。",
    lang92: "ゲーム参加",
    lang93: "ゲームルーム料金",
    lang94: "勝利",
    lang95: "プレイヤー",
    lang96: "精算露水",
    lang97: "場費",
    lang98: "底注",
    lang99: "/ゲーム",
    lang100: "自分の成績",
    lang101: "参加プレイヤー",
    lang102: "記録",
  },
  teenPatti: {
    recordTitle: "記録",
    rankingTitle: "ランキング",
    confirm: "確認",
    // 玩法设定页：配置与加入暂用 mock，接口接入后移除模拟提示。
    settingsTitle: "ゲーム設定",
    maxBet: "最大露水ベット",
    maxPot: "最大ポット",
    buyInDew: "持ち込み露水",
    mockJoinTip: "デモ：底露 {ante} を選択しました。参加機能は未接続です。",
    // 社团名称由 i18n-t 插槽提供，保持各语言的正确语序。
    clubPkRoom: "{club}のPKルーム",
    // 三张牌规则页文案：暂沿用此前的英文回退内容，待补充本语言翻译。
    title: "How to play",
    hands: "Hands",
    play: "Rules",
    order: "Hands ranked from highest to lowest",
    players: "Players: 2–5",
    mode: "Game mode:",
    intro: "Teen Patti is a strategy game in which players compare three-card hands. Read your hand and your opponents’ Dew wagers, then call, raise or compare hands to compete for the Dew in the pot. Suits do not determine hand strength.",
    flow: "Game flow",
    ante: "底露",
    anteText: "At the start of each game, the fixed base Dew set by the host is automatically deducted from every player and added to the pot.",
    deal: "Dealing",
    dealText: "Each player receives 3 face-down cards. Only the player can view their own cards after choosing to look at them.",
    turn: "Turns",
    turnText: "Players act in order until only one player remains, the pot limit is reached or the round limit is reached.",
    actions: "Player actions",
    blind: "Blind",
    blindText: "Wager Dew without looking at your cards. Calls and raises cost 1× the current Dew wager.",
    seen: "Seen",
    seenText: "Continue playing after viewing your cards. Calls and raises cost twice the blind player’s Dew wager.",
    compare: "Compare hands",
    condition: "Availability",
    conditionText: "Players can request a comparison from the second round onwards.",
    cost: "Cost",
    costText: "Requesting a comparison costs twice the current single Dew wager.",
    compareResult: "Result",
    compareResultText: "The requester can privately compare with any active player. If both hands have exactly the same type and ranks, the requester loses. The losing player is eliminated from the game.",
    fold: "Fold",
    foldText: "Leave the current game. Dew already contributed to the pot is not refunded.",
    allIn: "All in",
    allInText: "If your balance cannot cover the minimum call, you can put your entire remaining balance into the pot. You cannot take any more actions that game, but your hand is kept until the final showdown.",
    settlement: "Settlement",
    end: "Round limit",
    endText: "Each game has a maximum number of rounds to keep play moving. Refer to the limit displayed in the room.",
    showdown: "Showdown",
    showdownText: "When the round limit is reached, or only two players remain and one requests a showdown, the system reveals the remaining hands for a final comparison.",
    reward: "Dew reward",
    rewardText: "The winner receives the entire pot after the platform’s fixed-percentage service fee or commission has been deducted.",
    hand1: "Three of a kind",
    desc1: "Three cards of the same rank, such as AAA or 222",
    hand2: "Straight flush",
    desc2: "Three consecutive cards of the same suit, such as 4–5–6 of spades",
    hand3: "Flush",
    desc3: "Three cards of the same suit that are not consecutive",
    hand4: "Straight",
    desc4: "Three consecutive cards of mixed suits, such as 5♥, 6♦, 7♠",
    hand5: "Pair",
    desc5: "Two cards of the same rank and a third card, such as 223",
    hand6: "High card",
    desc6: "A hand that does not form any of the combinations above",
    hand7: "235",
    desc7: "A mixed-suit 2, 3 and 5 beats three of a kind only when a three-of-a-kind hand is present at the table. Otherwise, 235 is treated as a high-card hand.",
    rankOrder: "Within a hand type, A is highest and 2 is lowest. AAA is the highest three of a kind; 222 is the lowest. For straights and straight flushes, A–K–Q is highest and 3–2–A is lowest.",
    sameHand: "For flushes and high-card hands, compare the highest card first, then the second and third cards if tied. Suits have no ranking.",
    samePair: "For pairs, compare the pair first, then the remaining card if tied.",
    lang1: "ルームを開く",
    lang2: "クイック参加",
    lang3: "入場",
    lang4: "待機中",
    lang5: "現在 Teen Patti PK ルームはありません",
    lang6: "プレイモード",
    lang7: "デフォルトクラブ",
    lang8: "クラシック",
    lang9: "制限なし",
    lang10: "戦績",
    lang11: "ランキング",
    lang12: "入場露水",
    lang13: "プレイ情報",
    lang16: "入場露水を支払ってLudo PKに参加",
    lang17: "プレイヤー数",
    lang18: "勝利報酬",
    lang19: "名声",
    lang20: "マイアイテム",
    lang21: "駒",
    lang22: "盤面",
    lang23: "LUDOゲームで使用する駒アイテムを選択してください。",
    lang24:
      "LUDOゲームでクラブPKルームに使用する盤面アイテムを選択してください。",
    lang25: "時間バッジ",
    lang26: "選択済み",
    lang27: "デフォルト",
    lang28: "アイテムを選択してください",
    lang31: "使用",
    lang32: "使用するアイテムをタップして選択",
    lang33:
      "タップして使用すると、次のLUDOゲームでこの盤面アイテムが適用されます",
    lang34:
      "タップして使用すると、次のLUDOゲームでこの駒アイテムが適用されます",
    lang35: "使用中です",
    lang36: "使用するアイテムを選択してください",
    lang37: "使用成功、次のLUDOゲームで有効になります",
    lang38: "日",
    lang39: "時間",
    lang40: "分",
    lang42: "現在Teenpatti PK記録はありません",
    lang43: "ゲーム詳細",
    lang45: "ルーム料金",
    lang46: "時間",
    lang47: "露水",
    lang49: "日付",
    lang50: "合計",
    lang51: "プレイヤー头像",
    lang52: "順位",
    lang53: "1位",
    lang54: "2位",
    lang55: "3位",
    lang56: "4位",
    lang57: "読み込み中...",
    lang58: "カスタマーサービス",
    lang59: "勝",
    lang60: "負",
    lang61: "引き分け",
    lang62: "プレイ説明",
    lang63: "ゲームルール",
    lang64: "プレイヤー数",
    lang66: "勝敗判定",
    lang68: "クラブ名声",
    lang69: "ゲーム参加",
    lang70: "途中参加",
    lang72: "離陸",
    lang73: "三連六",
    lang74: "移動",
    lang75: "重なり駒",
    lang76: "駒を食べる",
    lang77: "安全地帯",
    lang78: "2-4人",
    lang79:
      "クラシック: プレイヤーの駒はスタート地点から盤面を一周してゴールに到達する必要があります。すべての駒がゴールに到達するとゲーム完了です。早く完了するほど順位が高くなります。",
    lang80:
      "プレイモードに応じて、先にゲームを完了したプレイヤーほど順位が高くなります。例えば最初に完了したプレイヤーがその試合の1位となり、以下同様です。",
    lang81: "ゲーム終了後、順位に応じて露水と名声報酬を獲得できます。",
    lang82:
      "参加中のクラブルームでゲームに勝利した場合、そのゲーム順位に応じてクラブ内名声が増加します。",
    lang83: "ルームオーナーが設定した入場露水を支払うとゲームに参加できます。",
    lang84:
      "すでに始まっているゲームでも、入場露水を支払えば途中からLudo PKに参加できます。",
    lang85:
      "サイコロで6を出さないと、駒は基地からスタートマスへ離陸できません。",
    lang86:
      "同一ターン内で6を3回出すと三連六が発動し、そのターンはスキップされます。",
    lang87: "プレイヤーはサイコロを振って出た目に応じた歩数だけ駒を進めます。",
    lang88:
      "同じプレイヤーの駒が同じ位置に止まると重なり駒になります。食べられると重なった駒はすべて基地に戻されます。",
    lang89:
      "移動後に他プレイヤーの駒があるマスに止まった場合、そのプレイヤーの駒はすべて基地に戻され、再び離陸しないと行動できません。",
    lang90:
      "盤面上のスタート地点と盾付きマスは安全地帯で、駒は食べられません。異なるプレイヤーの駒も同時にそこへ止まれます。",
    lang91:
      "各ゲームでは固定数量の露水がルーム料金として徴収されます。ルーム料金の金額は入場露水数に基づいて決まり、プレイヤー数とは関係ありません。ゲーム終了後に報酬露水を精算する際、システムは先にルーム料金を自動控除してから勝者への報酬露水を配布します。",
    lang92: "ゲーム参加",
    lang93: "ゲームルーム料金",
    lang94: "勝利",
    lang95: "プレイヤー",
    lang96: "精算露水",
    lang97: "場費",
    lang98: "底露",
  },
};
